import { createModalOptions } from 'modals/modal-options-factory';
import { useDispatch } from 'react-redux';
import { toggleModal } from 'state/callers';
import SyncGitTeamsWizard from './SyncGitTeamsWizard';
import useGitSelectedSyncTeamsSetting from '../useGitSelectedSyncTeamsSetting';
import useToast from 'components/hooks/useToast';

const useSyncedTeamsWizard = () => {
  const dispatch = useDispatch();
  const toast = useToast();
  const gitSelectedSyncTeamsSetting = useGitSelectedSyncTeamsSetting();

  const onSubmitSyncTeams = async ({
    sensorAuthId,
    orgName,
    selectedTeams
  }) => {
    try {
      dispatch(toggleModal());
      await gitSelectedSyncTeamsSetting.onSave(
        sensorAuthId,
        orgName,
        selectedTeams
      );
    } catch (e) {
      toast({
        message: `Failed to save team settings. Please try again later`,
        variant: 'error'
      });
    }
  };

  const toggleSyncTeamsModal = () => {
    dispatch(
      toggleModal(
        createModalOptions({
          content: () => (
            <SyncGitTeamsWizard
              onSubmit={onSubmitSyncTeams}
              onCancel={() => dispatch(toggleModal())}
              gitSelectedSyncTeamsSetting={gitSelectedSyncTeamsSetting}
            />
          ),
          width: '50%',
          height: '70%'
        })
      )
    );
  };

  return {
    toggleSyncTeamsModal
  };
};

export default useSyncedTeamsWizard;
